import styled from 'styled-components';

const Root = styled.div`
  border: 1px solid lightgray;
  padding: 15px;
  border-radius: 10px;
  margin-top: 15px;
`;

type Props = React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>;
export const CommonRoot = (props: Props) => {
  const { children, ...divProps } = props;
  return <Root {...divProps}>{children}</Root>;
};
